import "./SignIn.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginDataService from "../../../Services/LoginService";
import LoadingSpinner from "../../Controls/Spinner/LoadingSpinner";
import Alert from "../../Controls/Alerts/Alerts";
// import { useCookies } from "react-cookie";

const APISignIn = (props) => {
  // const [cookies, setUserNameCookie] = useCookies([""]);
  // const [signCookie, settabCookie] = useCookies([""]);
  let ru = "";
  let rpk = "";
  let rft = "";
  let ekey = "";
  const searchParams = new URLSearchParams(document.location.search);
  for (const [key, value] of searchParams) {
    if (key == "ru") ru = value;
    else if (key == "rpk") rpk = value;
    else if (key == "rft") rft = value.replace(" ", "+");
    else if (key == "ekey") ekey = value.replace(" ", "+");
  }
  const history = useNavigate();
  // settabCookie("SignIn", "SignIn");
  // let UserName = getCookie("UserName");
  // let UserTabSend = getCookie("TabSend");
  // let UserTabSignIn = getCookie("TabSignIn");
  // let UserTabCreate = getCookie("TabCreate");
  // let UserTabDocumentHistory = getCookie("TabDocumentHistory");
  // if (window.performance) {
  //   if (performance.navigation.type == 1) {
  //     settabCookie("TabSignIn", "Referesh");
  //   }
  // }

  const [openLoader, setOpen] = useState(false);
  localStorage.setItem("header", null);
  localStorage.setItem("UserName", "");
  localStorage.setItem("JWtToken", "");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [timer, setTimer] = useState("");

  // function getCookie(name) {
  //   var nameEQ = name + "=";
  //   var ca = document.cookie.split(";");
  //   for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i];
  //     while (c.charAt(0) == " ") c = c.substring(1, c.length);
  //     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  //   }
  //   return null;
  // }

  let value = 1;
  useEffect(() => {
    const onPageLoad = () => {
      submitForm();
    };

    // Check if the page has already loaded
    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener("load", onPageLoad);
    }
  }, []);
  async function submitForm() {
    if (ekey === "") {
      setAlertMsg("Invalid request.");
      setAlertType("warning");
      history("/");
    } else {
      setOpen(true);
      var loginData = {
        ekey: ekey,
      };
      var response = await LoginDataService.APILogin(ekey);
      if (response && response.status === 200) {
        localStorage.removeItem("DocumentID");
        setOpen(false);
        localStorage.setItem("header", "1");
        localStorage.setItem("UserName", response.data.email);
        localStorage.setItem("language", response.data.language);
        localStorage.setItem(
          "DateControlFormat",
          response.data.dateControlFormat
        );
        localStorage.setItem("UserRole", response.data.userRole);
        localStorage.setItem("Companyname", response.data.companyname);
        // setUserNameCookie("UserName", response.data.email);
        // settabCookie("TabSignIn", "Signed");
        setAlertType("sucess");
        let landingPage = [];

        landingPage = response.data.landingPage.split("_");

        if (landingPage.length > 1) {
          localStorage.setItem("ManageItem", landingPage[1]);
          history("/history");
          return;
        }

        if (landingPage[0] === "Generate") history("/create");
        else history(`/${landingPage[0]}`);

      } else if (response != null) {
        if (
          response.data.errorMessage ==
          "Your account has been blacklisted, please contact the administrator."
        )
          history("/blacklisted");
        else if (
          response.data.errorMessage ==
          "Your account has been suspended, please contact the administrator."
        )
          history("/suspended");
        else if (
          response.data.errorMessage ==
          "No subscription plan is assigned for this account. Please contact your company administrator."
        )
          history("/noplan");
        else {
          setAlertMsg("The session has expired. Please log-in again.");
          setAlertType("warning");
          setTimeout(() => {
            history("/");
          }, 2000);
        }
      } else {
        setOpen(false);
        setAlertMsg("The session has expired. Please log-in again.");
        setAlertType("warning");
        setTimeout(() => {
          history("/");
        }, 2000);
      }
    }
  }
  return (
    <>
      {openLoader ? <LoadingSpinner /> : null}
      <div className="container-login100">
        {/* alerts */}
        <Alert alertType={alertType} alertMsg={alertMsg} setAlertMsg={setAlertMsg} setAlertType={setAlertType} ></Alert>
        {/* end */}

        <img
          className="wave"
          src="assets/img/wave_yellow.svg"
          style={{ color: "f2d8da" }}
          alt="Wave"
        />
        <main className="login_wrapper my2">
          <div className="container">
            <div className="text-center mb-2">
              <img src="assets/img/RDocs.png" className="logo" alt="logo" />
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default APISignIn;
